"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQHDefaultSort = exports.QiQuanTXBJTable = void 0;
var react_1 = __importStar(require("react"));
var qtpager_1 = require("../qtpager");
var config_1 = require("../../modules/qihuo/config");
require("./index.less");
/**
 * 期货-期权-t型报价表格
 * @returns
 */
function QiQuanTXBJTable(props) {
    var _a;
    var mt = (_a = props.mt) !== null && _a !== void 0 ? _a : 0;
    var _b = (0, react_1.useState)([]), showdata = _b[0], SetShowData = _b[1];
    var _c = (0, react_1.useState)(0), count = _c[0], SetCount = _c[1];
    (0, react_1.useEffect)(function () {
        var qihuodata = props.qihuodata;
        if (qihuodata.result.length > 0) {
            var list = formatTxbjList(qihuodata.result);
            SetShowData(list);
        }
        SetCount(qihuodata.count);
    }, [props.qihuodata]);
    var changeSort = function (tosortitem) {
        props.changeSort && props.changeSort(tosortitem);
    };
    // console.log(tableitem)
    // return <></>
    return (react_1.default.createElement("div", { className: "quotetable_txbj", style: mt > 0 ? { marginTop: mt } : {} },
        react_1.default.createElement("table", null,
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null, props.tableitem.filter(function (v) { return v.hide != true; }).map(function (v, index) {
                    return react_1.default.createElement("th", { key: index, className: v.sort ? 'sort' : '', title: v.sort ? '点击排序' : '', onClick: function () { if (v.sortby) {
                            changeSort(v.sortby);
                        } } },
                        v.title,
                        v.tip && react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: v.tip } }),
                        v.sortby && v.sortby.split(",")[1] == props.sortitem && props.sortdirect == 'desc' &&
                            react_1.default.createElement("span", { className: "icon_down" }),
                        v.sortby && v.sortby.split(",")[1] == props.sortitem && props.sortdirect == 'asc' &&
                            react_1.default.createElement("span", { className: "icon_up" }));
                }))),
            react_1.default.createElement("tbody", null, showdata.map(function (v, index) {
                return react_1.default.createElement("tr", { key: index },
                    react_1.default.createElement("td", { className: v.gouBgColor }, v.gouName),
                    react_1.default.createElement("td", { className: v.gouBgColor }, v.gouZxj.html),
                    react_1.default.createElement("td", { className: v.gouBgColor }, v.gouZdf.html),
                    react_1.default.createElement("td", { className: v.gouBgColor }, v.gouZde.html),
                    react_1.default.createElement("td", { className: v.gouBgColor }, v.gouCcl.html),
                    react_1.default.createElement("td", { className: v.gouBgColor }, v.gouCjl.html),
                    react_1.default.createElement("td", { className: v.gouBgColor }, v.gouYxbd.html),
                    react_1.default.createElement("td", { className: v.gouBgColor }, v.gouZYjl.html),
                    react_1.default.createElement("td", { className: "xq_orange" }, v.Xqj.html),
                    react_1.default.createElement("td", { className: v.guBgColor }, v.guName),
                    react_1.default.createElement("td", { className: v.guBgColor }, v.guZxj.html),
                    react_1.default.createElement("td", { className: v.guBgColor }, v.guZdf.html),
                    react_1.default.createElement("td", { className: v.guBgColor }, v.guZde.html),
                    react_1.default.createElement("td", { className: v.guBgColor }, v.guCcl.html),
                    react_1.default.createElement("td", { className: v.guBgColor }, v.guCjl.html),
                    react_1.default.createElement("td", { className: v.guBgColor }, v.guYxbd.html),
                    react_1.default.createElement("td", { className: v.guBgColor }, v.guZYjl.html));
            }))),
        count > 0 &&
            react_1.default.createElement(qtpager_1.QTPager, { count: count, pagesize: props.pagesize, nowindex: props.nowindex, onChangePager: function (toindex) { props.onChangePager(toindex); } })));
}
exports.QiQuanTXBJTable = QiQuanTXBJTable;
/**
 * 获取期货默认的排序设置
 * @param config
 * @returns
 */
function getQHDefaultSort(config) {
    var finddefault = config.find(function (v) { return v.sort_default; });
    if (finddefault) {
        return {
            cp: finddefault.sortby ? finddefault.sortby.split(",")[0] : "",
            orderby: finddefault.sortby ? finddefault.sortby.split(",")[1] : "",
            sort: finddefault.sort,
            sort_direct: finddefault.sort_direct
        };
    }
    return {
        cp: 'c',
        sort: '',
        sort_direct: 'desc',
        orderby: ''
    };
}
exports.getQHDefaultSort = getQHDefaultSort;
/**
 * bgcolor
 * @param type
 * @param bddqj 标的当前价
 * @param xqj 行权价
 * @returns
 */
function getBJColor(type, bddqj, xqj) {
    var diff = !!xqj ? parseFloat(bddqj) - parseFloat(xqj) : parseFloat(bddqj);
    return !!diff ? (diff == 0 ? '' : diff > 0 ? "bj_bg_red" : "bj_bg_green") : '';
}
/**
 * 数据格式化
 * @param list
 * @returns
 */
function formatTxbjList(list) {
    try {
        var back = list.map(function (v) {
            var callQt = v.callQt, // 购
            putQt = v.putQt; // 估
            var gouBgColor = getBJColor('gou', callQt.bddqj, callQt.xqj);
            var guBgColor = getBJColor('gu', putQt.bddqj, putQt.xqj);
            return {
                gouBgColor: gouBgColor,
                gouName: getLinkName(callQt.name, callQt.sc, callQt.dm),
                gouZxj: (0, config_1.qihuoItem)(callQt.p, 0, callQt.zde, 0, "", callQt.zsjd),
                gouZdf: (0, config_1.qihuoItem)(callQt.zdf, -1, callQt.zde, -1, "%", 2),
                gouZde: (0, config_1.qihuoItem)(callQt.zde, 0, callQt.zde, 0, "", callQt.zsjd),
                gouCcl: (0, config_1.qihuoItem)(callQt.ccl, -1, 0, 4, "", 2),
                gouCjl: (0, config_1.qihuoItem)(callQt.vol, -1, 0, 4, "", 2),
                gouYxbd: (0, config_1.qihuoItem)(callQt.yhbdl, -1, 0, -1, "%", 2),
                gouZYjl: (0, config_1.qihuoItem)(callQt.zyjl, -1, 0, -1, "%", 2),
                Xqj: (0, config_1.qihuoItem)(callQt.xqj, 0, 0, 0, ""),
                guBgColor: guBgColor,
                guName: getLinkName(putQt.name, putQt.sc, putQt.dm),
                guZxj: (0, config_1.qihuoItem)(putQt.p, 0, putQt.zde, 0, "", putQt.zsjd),
                guZdf: (0, config_1.qihuoItem)(putQt.zdf, -1, putQt.zde, -1, "%", 2),
                guZde: (0, config_1.qihuoItem)(putQt.zde, 0, putQt.zde, 0, "", putQt.zsjd),
                guCcl: (0, config_1.qihuoItem)(putQt.ccl, -1, 0, 4, "", 2),
                guCjl: (0, config_1.qihuoItem)(putQt.vol, -1, 0, 4, "", 2),
                guYxbd: (0, config_1.qihuoItem)(putQt.yhbdl, -1, 0, -1, "%", 2),
                guZYjl: (0, config_1.qihuoItem)(putQt.zyjl, -1, 0, -1, "%", 2), //认购折溢价率
            };
        });
        return back;
    }
    catch (error) {
        return [];
    }
}
function getLinkName(name, market, code) {
    return react_1.default.createElement("a", { href: "//quote.eastmoney.com/unify/r/".concat(market, ".").concat(code) }, name);
}
